import { render } from "./App.vue?vue&type=template&id=ebd65836"
const script = {}

import "@/assets/scss/app.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__